import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { Close, WarningAmberRounded } from "@mui/icons-material";

const ConfirmDialog = ({ open, onClose, onConfirm, title, content, loading=false }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        borderRadius: 10,
        px: 2,
        py: 1,
        boxShadow: 10,
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberRounded color="warning" />
        <Typography fontWeight="bold" variant="h6">
          {title}
        </Typography>
        <Box flexGrow={1} />
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onConfirm}
          variant="text"
          sx={{
            color: "error.main",
            "&:hover": {
              backgroundColor: "error.light",
              color: "white",
            },
          }}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
